import script from "./BlogPost.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogPost.vue?vue&type=script&lang=ts&setup=true"

import "./BlogPost.vue?vue&type=style&index=0&id=50d228c0&lang=scss"

const __exports__ = script;

export default __exports__